export default __webpack_public_path__ + "static/media/vivez_clichy_marker.d866afb2.jpeg";